export const isLocalhostSite = (): boolean => {
    const isLocal = ['localhost', '127.0.0.1'].includes(location.hostname)
    const isTunnel = location.hostname.includes('devtunnels.ms')
    return isLocal || isTunnel
}

export const getMainDomain = (): string => {
    return isLocalhostSite()
        ? '127.0.0.1'
        : location.hostname.substring(location.hostname.lastIndexOf('.', location.hostname.lastIndexOf('.') - 1) + 1)
}

export const backendUrl = isLocalhostSite()
    ? '/api'
    : `${(import.meta as any).env.VITE_BACKEND_BASE_URL?.replace('_{HOST}_', getMainDomain()) ?? ''}`

export const GetImageUrl = (strangePath: string): string => (import.meta as any).env.VITE_IMAGE_BASE_URL + strangePath
